<template>
  <ion-page><cyan-page-wrapper title="Elegir departamento" :burst="true" backRoute="/partyLevels" nav1="MODO PARTIDO">
    <mapa-sv nextRoute="/partyList/" :key="'mapaPickDepto'"/>
    <territory-picker nextRoute="/partyList/" />
  </cyan-page-wrapper></ion-page>
</template>

<script lang="ts">
import CyanPageWrapper, { defineComponent, IonPage } from '@/components/CyanPageWrapper.vue'
import TerritoryPicker from '@/components/TerritoryPicker.vue';
import MapaSv from '@/components/MapaSv.vue';

export default defineComponent({
  name: "PickDepto",
  components: {
    TerritoryPicker,
    CyanPageWrapper,
    IonPage,
    MapaSv
  },
  computed: {},
  methods: {}
});
</script>
